import AOS from 'aos';

$(function() {
    AOS.init({
        duration: 800,
        easing: 'ease-in-out',
        once: true,
        offset: 100
    });

    $('.submenu a').click(function() {
        if ($( window ).width() < 992) {
            $('.offcanvas__info').removeClass('info-open');
            $('.offcanvas__overlay').removeClass('overlay-open');
            $(this).parents('.dropdown-opened').removeClass('dropdown-opened');
            $(this).parents('.submenu').css('display', 'none');
            $(this).parents('.submenu').next('.mean-expand').removeClass('mean-clicked');
        }
    });
})
